import { css } from '@emotion/react';
import { addParamsToUrl } from '@zapier/url-utils';

import { Link, Typography } from '@zapier/design-system';
import { urls, useSize } from '@zapier/identity-utils';

import {
  AuthLayout,
  CompaniesIntroPromo,
} from '@zapier/auth-pages/src/components/global';

const textStyle = css`
  ${Typography.paragraph1}
  text-align: center;
`;

const rootStyle = css`
  display: grid;
  gap: 20px;
  padding: 40px 0;
`;

export function ActivateAccountPage() {
  const size = useSize();
  const titleText = 'Thanks for signing up';

  return (
    <AuthLayout
      promo={<CompaniesIntroPromo />}
      showPromo={size !== 'small'}
      title={titleText}
      titlePosition={'right'}
    >
      <section css={rootStyle}>
        <p css={textStyle}>Thanks for signing up. We’re happy you’re here!</p>

        <p css={textStyle}>
          We&apos;ve sent a link to your email that you can use to set a
          password and activate your Zapier account.
        </p>
        <p css={textStyle}>
          Link not working?{' '}
          <Link
            href={addParamsToUrl(urls.HELP_URL, {
              account: 'other',
              topic: 'account',
            })}
          >
            Get help.
          </Link>
        </p>
      </section>
    </AuthLayout>
  );
}
